import React, { useEffect, useRef, useState } from 'react'
import { eapiClient } from '../../../../../restClient'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../../common/Modal'

const AdditionalCommentWIthImage = (props) => {
    const { showDialog, toggleDialog, bsClass, modalTitle = "Additional Comment", addCommentBtn = "Save", addCommentLabel = '', noteOne, noteTwo,
        sowId, blockUi, unBlockUi } = props
    const [comment, setComment] = useState({})
    const [totalSize, setTotalSize] = useState(0)
    const addCommentRef = useRef(null)

    const getFormattedComments = () => {
        const elements = []
        try {
            const content = addCommentRef.current.innerHTML
            const parser = new DOMParser()
            const doc = parser.parseFromString(content, 'text/html')

            const traverseNodes = (node) => {
                for (let index = 0; index < node.childNodes.length; index++) {
                    const child = node.childNodes[index];
                    if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
                        elements.push({
                            type: 'text',
                            content: child.textContent
                        })
                    } else if (child.nodeName === 'IMG') {
                        elements.push({
                            type: 'image',
                            content: child.getAttribute('src')
                        })
                    } else {
                        traverseNodes(child)
                    }
                }
            }

            traverseNodes(doc.body)
            return elements
        } catch (error) {
            console.log(error)
            return []
        }
    }

    const handleClose = () => {
        toggleDialog()
    }

    const handlePaste = (e) => {
        e.preventDefault()
        const items = (e.clipboardData || window.clipboardData).items
        for (const item of items) {
            if (item.kind === 'file' && item.type.startsWith('image/')) {
                const file = item.getAsFile()
                const reader = new FileReader()
                reader.onload = (event) => {
                    const imageNode = getNodeElement(event.target.result, "image")
                    addCommentRef.current.appendChild(imageNode)
                }
                reader.readAsDataURL(file)
            } else if (item.kind === 'string') {
                item.getAsString((clipboardData) => {
                    const textNode = getNodeElement(clipboardData, "text")
                    addCommentRef.current.appendChild(textNode)
                })
            }
        }
    }

    const getNodeElement = (data = '', type = '', wrapDiv) => {
        let node = document.createTextNode('')
        if (type === 'image') {
            node = document.createElement('img')
            node.src = data
            node.style.maxWidth = "100%"
            node.style.height = "auto"
            node.style.margin = "0.5rem 0px"
        }
        else if (type === 'text') {
            if (wrapDiv) {
                node = document.createElement('div')
                node.innerText = data.replace(/<[^]*>/g, '')
            } else {
                node = document.createTextNode(data.replace(/<[^]*>/g, ''))
            }
        }
        return node
    }

    const handleAddComment = () => {
        saveBillingComment(getFormattedComments())
    }

    useEffect(() => {
        getBillingComment()
    }, [])

    const getBillingComment = async () => {
        blockUi && blockUi();
        const { data } = await eapiClient('/sows/getSowBillingComment/' + sowId)
        unBlockUi && unBlockUi();
        if (data.responseData) {
            setComment(data.responseData)
            updateAddCommentRef(data.responseData.notes)
        }
    }

    const saveBillingComment = async (notes = []) => {
        const payload = {
            sowId: sowId,
            notes,
            id: comment.id
        }
        blockUi && blockUi();
        try {
            const { data } = await eapiClient('/sows/saveSowBillingComment', { method: 'POST', data: JSON.stringify(payload) })
            unBlockUi && unBlockUi()
            handleClose()
        } catch (error) {
            setTotalSize(1)
            console.log(error)
        }
    }

    const updateAddCommentRef = (notes = []) => {
        if (notes && notes.length) {
            notes.forEach(({ type, content }) => {
                const node = getNodeElement(content, type, true)
                addCommentRef.current.appendChild(node)
            })
        }
    }

    // const calculateDataSize = () => {
    //     try {
    //         const divRef = addCommentRef.current
    //         const childElements = divRef.childNodes
    //         let totalSize = 0
    //         for (let index = 0; index < childElements.length; index++) {
    //             const childElement = childElements[index];
    //             if (childElement.nodeType === Node.ELEMENT_NODE) {
    //                 if (childElement.tagName === 'IMG') {
    //                     totalSize += childElement.naturalWidth * childElement.naturalHeight * 3
    //                 }
    //                 else if (childElement.tagName === 'TEXT') {
    //                     totalSize += childElement.textContent.length
    //                 }
    //             }
    //         }
    //         const parsedSize = (totalSize / 1024 / 1024).toFixed(2)
    //         setTotalSize(parsedSize)
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    // useEffect(() => {
    //     calculateDataSize()
    // }, [comment.notes, addCommentRef.current])

    return (
        <Modal
            show={showDialog}
            onClose={handleClose}
            bsClass={bsClass}
        >
            <ModalHeader title={modalTitle} />
            <ModalBody>
                <div className="comments-conatiner">
                    <div className="add-comments-section">
                        <label htmlFor="add-comment">{addCommentLabel}</label>
                        <div className='add-comment-notes'>
                            <div>{noteOne}</div>
                            <div>{noteTwo}</div>
                        </div>
                        <div style={{ borderColor: totalSize ? '#db0011' : '#767676' }} ref={addCommentRef} contentEditable="true" className='additional-comment-content-editable-textarea' ></div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <hr></hr>
                <button
                    className="gdocs-btn-primary"
                    onClick={handleAddComment}
                >
                    {addCommentBtn}
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default AdditionalCommentWIthImage



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/CashConcentrationSummary/AdditionalCommentWithImage/index.js